import React from "react";
import { Mail, Phone, MapPin } from "lucide-react";
import Panel from "../../components/ui/Panel/Panel.jsx";
import PageHeader from "../../components/marketing/PageHeader.jsx";
import { SUPPORT_EMAIL, SUPPORT_PHONE_DISPLAY, SUPPORT_PHONE_TEL } from "../../components/ui/HelpSupportModal/HelpSupportModal.jsx";
import SeoHead from "../../seo/SeoHead.jsx";
import { ROUTE_META } from "../../seo/siteMeta.js";
import { breadcrumbSchema } from "../../seo/schema.js";

const meta = ROUTE_META["/contact"];

const Contact = () => (
  <div className="max-w-[860px] mx-auto px-[22px] py-[46px] pb-[70px]">
    <SeoHead
      title={meta.title}
      description={meta.description}
      path="/contact"
      keywords={meta.keywords}
      schemas={[breadcrumbSchema([{ name: "Home", path: "/" }, { name: "Contact", path: "/contact" }])]}
    />
    <PageHeader eyebrow="Contact" title="Contact us">
      Have a question about filing Form 2290, your account, or billing? Our support team is here to help.
    </PageHeader>

    <div className="grid sm:grid-cols-2 gap-4 mt-8">
      <Panel padded pop className="h-full">
        <div className="w-9 h-9 rounded-lg bg-[var(--accent-soft)] text-[var(--accent)] grid place-items-center mb-3">
          <Mail size={17} />
        </div>
        <b className="font-disp text-[16px]">Email support</b>
        <p className="text-[var(--muted)] text-[15px] leading-[1.6] mt-2 mb-4">
          The fastest way to reach us for help with filing, your account, or billing.
        </p>
        <a
          href={`mailto:${SUPPORT_EMAIL}`}
          className="inline-flex items-center gap-2 px-5 py-2.5 rounded-[10px] bg-[var(--accent-fill)] text-[var(--accent-ink)] text-[15px] font-semibold no-underline hover:brightness-[1.06] transition-all"
        >
          {SUPPORT_EMAIL}
        </a>
      </Panel>

      <Panel padded pop className="h-full">
        <div className="w-9 h-9 rounded-lg bg-[var(--accent-soft)] text-[var(--accent)] grid place-items-center mb-3">
          <Phone size={17} />
        </div>
        <b className="font-disp text-[16px]">Call us</b>
        <p className="text-[var(--muted)] text-[15px] leading-[1.6] mt-2 mb-4">
          Prefer to talk it through? Give us a call.
        </p>
        <a
          href={`tel:${SUPPORT_PHONE_TEL}`}
          className="inline-flex items-center gap-2 px-5 py-2.5 rounded-[10px] border-[1.5px] border-[var(--accent)] text-[var(--accent)] text-[15px] font-semibold no-underline hover:bg-[var(--accent-soft)] transition-all"
        >
          {SUPPORT_PHONE_DISPLAY}
        </a>
        <p className="text-[13px] text-[var(--muted)] mt-3">
          <span className="font-semibold text-[var(--ink)]">Business hours:</span> Monday–Friday, 9 AM – 6 PM CT
        </p>
      </Panel>

      <Panel padded pop className="h-full sm:col-span-2">
        <div className="w-9 h-9 rounded-lg bg-[var(--accent-soft)] text-[var(--accent)] grid place-items-center mb-3">
          <MapPin size={17} />
        </div>
        <b className="font-disp text-[16px]">Mailing address</b>
        <p className="text-[var(--muted)] text-[15px] leading-[1.6] mt-2">
          Quantiva LLC
          <br />
          2591 Dallas Parkway, Suite 300 PMB 231
          <br />
          Frisco, TX 75034
          <br />
          United States
        </p>
      </Panel>
    </div>

    <p className="text-[13px] text-[var(--muted)] leading-[1.6] mt-6">
      EasyFile2290 is a product of Quantiva LLC. For privacy or data requests, please see our{" "}
      <a href="/privacy" className="text-[var(--accent)] font-semibold no-underline hover:underline">
        Privacy Policy
      </a>
      .
    </p>
  </div>
);

export default Contact;
